import { useAuthStore } from '@/v2/store/shared/auth-store';
import { useChatsStore } from '@/v2/modules/whatsapp/stores/chats';
import { useConversationStore } from '@/v2/modules/whatsapp/stores/conversation';
import { Alert } from '@/v2/plugins/alert';
import { t } from '@/locales/index';

export const assignSelectedConversationToMe = () => {
	const authStore = useAuthStore();
	const chatsStore = useChatsStore();
	const conversationStore = useConversationStore({
		channelType: chatsStore.selectedConversationChannelType,
		conversationId: chatsStore.selectedConversationId,
	});
	if (!conversationStore.conversation.assigned_to_user) {
		conversationStore.conversation.assignUserToConversation(
			authStore?.user?.id,
			authStore?.user?.full_name,
		);
		Alert.success(t('whatsapp.conversation-assigned-to-you'));
	}
};
